import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@material-ui/core";

import { getData, api, formatDatetime } from "../../../../services";
import { Table } from "../../../../components/table";
import { NoTableData } from "../../../../components/parts";
import TrashIcon from "../../../../assets/images/icons/trash.svg";

const cellStyle = { padding: "18px 0 18px 32px" };

export const TenantAlert = ({ tId }) => {
  const [alerts, setAlerts] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/tenants/${tId}/alerts/`, setAlerts);

    return () => setAlerts([]);
  }, []);

  const handleClick = (i) => {
    api.delete(`/praas/v2/buildings/${id}/tenants/${tId}/alerts/${alerts[i]?.id}/`).then(() => {
      const tempAlerts = [...alerts];
      tempAlerts.splice(i, 1);
      setAlerts(tempAlerts);
    });
  };

  if (!alerts.length) return <NoTableData title="No alerts yet" />;

  return (
    <Box>
      <Table
        headers={["Type", "Date", "Description"]}
        data={alerts.map((alert) => [
          alert.type,
          formatDatetime(alert.created_at, "MMM DD, YYYY"),
          alert.description,
        ])}
        colWidths={[25, 18, 52, 5]}
        endIcon={TrashIcon}
        onEndIconClick={(i) => handleClick(i)}
        cellStyles={[cellStyle, cellStyle, cellStyle, cellStyle]}
      />
    </Box>
  );
};
